import EventBus from '@/scripts/event-bus';
import BoardUtility from '@/scripts/board-utility';
import { SocialMediaPostTemplateService } from '@/scripts/services/social-media/social-media-post-template-service';
import { api } from '@/scripts/api';
import { LogLevel } from '@/scripts/logger';

export const SocialPostTemplateBoardServiceMixin = {
    data() {
        return {
            deletingItems: [],
        };
    },

    methods:{
        refreshEvent() {
            EventBus.$emit('social-post-templates:update');
        },

        handleEditPostTemplate(item, accountId) {
            EventBus.$emit('open-widget', {
                templateId: item.postTemplate.id,
                name: 'social-post-template-widget',
                step: 'summary-post-review',
                isBuilderView: false,
                options: {
                    title: 'Edit Post Template',
                    accountId: accountId
                },
            });
        },

        asSocialPostTemplateItem(item, accountId) {
            const obj = {
                id: item.Id,
                postTemplate: {
                    id: item.Id,
                    name: item.TemplateName,
                    thumbnailImageUrl: item.SmallThumbnail,
                    redirectTo: `${ this.baseUrl }/SocialMedias/PostTemplates/Template/${ item.Id }/View`,
                },
                autoPublished: {
                    socialPostTemplateId: item.Id,
                    isAutoPublished: item.AutoPublish,
                    name: item.TemplateName,
                    accountId: accountId
                },
                publishedTo: {
                    socialPostTemplateId: item.Id,
                    isAutoPublished: item.AutoPublish,
                    published: item.PublishedTo,
                    accountId: accountId
                },
                plansPublishedTo: item.PromoIdsPublished ? item.PromoIdsPublished.length : 0,
                vendor: {
                    name: item.SharingVendorName,
                    logoUrl: item.SharingVendorLogoUrl
                },
                createdAt: this.$moment(item.CreatedAt),
                updatedAt: this.$moment(item.LastModified),
                publishedAt: this.$moment(item.PublishedDate).local(),
                categories: item.Categories.map((item) => {
                    return {
                        name: item,
                    };
                }),
            };

            if(item.Statistics){
                obj.statistics = {
                    clicks: item.Statistics.Clicks,
                    impressions: item.Statistics.Impressions,
                    reach: item.Statistics.Reach,
                    shares: item.Statistics.Shares,
                    engagement: item.Statistics.Engagement,
                    partnersPublishedTo: item.PublishedTo,
                    publishedSocialNetworks: this.getSocialNetworkUrls(item.PublishedToNames),
                    addedToTemplates: item.Statistics.AddedToTemplates,
                    previewed: item.Statistics.Previewed,
                    sent: item.Statistics.Sent,
                }
            }

            return  obj;
        },

        getSocialNetworkUrls(socialNetworks) {
            const socialNetworkUrls = {
                facebookUrl: null,
                twitterUrl: null,
                linkedinUrl: null,
                instagramUrl: null,
                youtubeUrl: null
            };

            socialNetworks.forEach(network => {
                const key = `${network}Url`;
                if (socialNetworkUrls.hasOwnProperty(key)) {
                    socialNetworkUrls[key] = '/';
                }
            });

            return socialNetworkUrls;
        },

        saveNameCell(payload, accountId) {
            const postId = payload.item.postTemplate.id;
            const body = {
                templateName: payload.value,
            };

            SocialMediaPostTemplateService.patch(postId, accountId, body)
                .catch((error) => {
                    this.$helpers.showFailNotification('Error trying to update the post template name', { error });
                });
        },

        handleDuplicatePostTemplate(item, accountId) {
            const widget = {
                name: 'duplicate-widget',
                entityName: item.postTemplate.name,
                entityType: 'Social post template',
                fieldLabel: 'Choose a name for the new social post template',
                fieldPlaceholder: 'Post template name',
                isSocialMedia: true,
                onSubmit(form) {
                    return new Promise((resolve, reject) => {
                        const body = {
                            id: item.postTemplate.id,
                            templateName: form.newEntityName,
                        }

                        SocialMediaPostTemplateService.duplicate(accountId, body)
                            .then(resolve)
                            .catch(reject) 
                    });
                },

                onSuccess: () => {
                    this.refreshEvent();
                },
            };

            EventBus.$emit('open-widget', widget);
        },

        handleCreateSocialPost(item, accountId, clientId){
            const widget = {
                name: 'create-social-post-widget',
                step: 'existing-template-edit',
                options: {
                    title: 'Social Media Post',
                    template: item,
                    accountId: accountId,
                    clientId: clientId
                }
            }

            EventBus.$emit('open-widget', widget);
        },

        handleAddToMyPostTemplates(item, accountId) {
            const body = {
                id: item.postTemplate.id,
                templateName: item.postTemplate.name,
            }

            SocialMediaPostTemplateService.duplicate(accountId, body)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        'You\'ve successfully added the social post template to My Templates.'
                    );
                    this.refreshEvent();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'There was an error adding the social post template.',
                    { error }
                    );
                }) 
                  
        },

        
        handlePublishPostTemplate(item, accountId){
            if (!item.autoPublished.isAutoPublished) {
                const widget = {
                    name: 'social-post-template-publish-widget',
                    options:{
                        templateId: item.postTemplate.id,
                        accountId: accountId
                    }
                };

                EventBus.$emit('open-widget', widget);
            } else {
                this.$helpers.showFailNotification('This template is already set to Auto Publish', { level: LogLevel.INFO });
            }
        },

        handleUnpublishPostTemplate(item, accountId){
             SocialMediaPostTemplateService.unpublish(item.postTemplate.id, accountId)
             .then(() => {
                    this.$helpers.showSuccessNotification('Your publish settings have been updated.');
                    this.refreshEvent();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while saving your landing page publish settings.', { error });
                })
        },

        createDeletePostTemplateModal(item, accountId){
            const actions = {
                confirm: {
                    label: 'Ok',
                    action: () => this.deleteItem(item, accountId),
                },

                cancel: {
                    label: 'Cancel',
                },
            };

            const popUpProps = {
                title: 'Are you sure?',
                content: '<p>The social post template will be deleted, this action can\'t be undone.</p>',

                actions,
            };

            this.showPopup(popUpProps, 'alert-popup');
        },

        getFilterParam(options) {
            const queryFilters = [];
           
            if (options.filters) {
                const viewQueryFilter = this.getViewQueryFilter(options.filters);

                if (viewQueryFilter) {
                    queryFilters.push(viewQueryFilter);
                }
            }

            if(options.dateRange){
                const [startDate, endDate] = options.dateRange
                queryFilters.push(
                    `"startDate":"${startDate}"`
                );
                queryFilters.push(
                    `"endDate":"${endDate}"`
                );
            }

            if (options.search) {
                queryFilters.push(
                    `"TemplateName": {"$like": "${encodeURIComponent(`%${options.search}%`)}"}`
                );
            }

            const postTypes = {
                myTemplates: 'my_templates',
                sharedTemplates: 'shared_resource',
                subscriptionTemplates: 'promo_included',
                published: 'published',
                unpublished: 'unpublished'
            };
            
    
            const typeParam = postTypes[options.type] || null;

            if(typeParam){
                if (typeParam === 'published' || typeParam === 'unpublished') {
                    if(options.promoIds){
                        queryFilters.push(`"ValidPromoIds": [${options.promoIds}]`)
                    }
                    queryFilters.push(`"IsPublished": ${typeParam === 'published'}`);
                } else {
                    queryFilters.push(`"TemplateType": "${typeParam}"`);
                }
            }

            if (options.promoId) {
                queryFilters.push(`"PromoId": ${options.promoId}`);
            }
             
            return queryFilters.length > 0 ? `{${queryFilters.join(',')}}` : null;
        },

        getViewQueryFilter(filters) {
            if (filters.value.length > 0) {
                const viewQueryFilters = filters.value.map(this.mapFilter);

                if (filters.operation === 'Or') {
                    return `"$or": [${viewQueryFilters.join(', ')}]`;
                } else {
                    return `"$and": [${viewQueryFilters.join(', ')}]`;
                }
            }

            return null;
        },

        mapFilter(filter) {
            switch (filter.key) {
                case 'name':
                    return BoardUtility.getSocialPostTemplateNameFilter(filter);
                case 'vendor':
                    return BoardUtility.getSocialPostTemplateVendorFilter(filter);
                case 'categories':
                    return BoardUtility.getSocialCategoriesFilter(filter);
                default:
                    return null;
            }
        },

        getOffsetParam(options) {
            return options.itemsPerPage && options.page
                ? `${options.itemsPerPage * (options.page - 1)}`
                : null;
        },

        getLimitParam(options) {
            return options.itemsPerPage ? `${options.itemsPerPage}` : null;
        },

        getOrderParam(options) {
            return options.sort
                ? `["${options.sort.property}", "${options.sort.direction.toUpperCase()}"]`
                : null;
        },

        createParamsFromBoardQuery(options) {
            return {
                filter: this.getFilterParam(options),
                skip: this.getOffsetParam(options),
                limit: this.getLimitParam(options),
                order: this.getOrderParam(options),
                count: true,
            };
        },

        deleteItem(item, accountId) {
            const id = item.postTemplate.id;
 
            this.deletingItems = [item];

            SocialMediaPostTemplateService.delete(id, accountId)
                .then(() => {
                    this.$helpers.showSuccessNotification('Social post template deleted successfully.');
                    this.refreshEvent();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Error trying to delete social post template.', { error });
                })
                .finally(() => {
                    this.deletingItems = []
                });
        },

        getSocialPostTemplates(options, accountId , signal) {
            const requestConfig = this.createParamsFromBoardQuery(options);

            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.getAll(requestConfig, accountId, signal)
                .then(({ data }) => resolve({
                    items: data.data.map((item) => this.asSocialPostTemplateItem(item, accountId)),
                    totalItems: data.count
                }))
                .catch(reject);
            })
        },

        patchTemplatePreviewCount(templateId, accountId){
            return new Promise((resolve, reject) => {
                SocialMediaPostTemplateService.patchPreview(templateId, accountId).then(resolve).catch(reject);
            })

        },

        getPromosData(){
            const service = '/service/Promos?';

            return new Promise((resolve, reject) => {
                api.get(service).then(({data}) => {
                        resolve({
                            items: data.value.map((item) => item.Id)
                        });
                })
                .catch(reject);
            })
        }
    }
}